import React from 'react';
import classnames from 'classnames';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { SideBarItem } from 'components';

const useStyles = createUseStyles((theme: Theme) => ({
  icon: {
    fontSize: 16,
  },
  iconValid: {
    color: theme.colors.green,
  },
  iconError: {
    color: theme.colors.red,
  },
}));
interface Props {
  text: string;
  to: string;
  relativeMatchPosition: number;
  completed?: boolean;
}

export const EditSessionNavItem = ({
  relativeMatchPosition,
  completed,
  ...props
}: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });

  if (completed) {
    return (
      <SideBarItem
        {...props}
        icon="ri-checkbox-circle-fill"
        iconClassName={classnames(classes.icon, classes.iconValid)}
      />
    );
  }
  return (
    <SideBarItem
      {...props}
      icon="ri-checkbox-blank-circle-line"
      iconClassName={classes.icon}
      variant={relativeMatchPosition > 0 ? 'grayish' : undefined}
    />
  );
};
